module.exports = __webpack_public_path__ + "static/media/mito03.0ce30390.jpg";